import { cx } from '@/lib/cx'

export type VarianteBoton = 'primario' | 'secundario' | 'neutro' | 'destructivo'
export type TamanoBoton = 'fila' | 'normal' | 'movil' | 'campo'

const variantes: Record<VarianteBoton, string> = {
  primario: 'bg-brand text-white hover:bg-rey-700 disabled:bg-deshabilitado',
  secundario:
    'bg-rey-50 text-rey-800 border border-rey-200 hover:bg-rey-100 disabled:text-deshabilitado',
  neutro: 'bg-tarjeta text-tinta border border-linea hover:bg-cabeza disabled:text-deshabilitado',
  destructivo:
    'bg-alerta-bloqueo-bg text-alerta-bloqueo-texto border border-alerta-bloqueo-borde hover:bg-alerta-bloqueo-icono-bg disabled:text-deshabilitado',
}

const tamanos: Record<TamanoBoton, string> = {
  fila: 'h-accion-fila min-w-accion-fila px-2 text-small rounded-fila',
  normal: 'h-control px-4 text-label rounded-boton',
  movil: 'h-control-movil px-5 text-label rounded-boton',
  campo: 'min-h-[64px] px-5 text-campo rounded-seccion',
}

/** Las clases de un botón, para un enlace que se ve como botón (navegar no es una acción). */
export const clasesBoton = (variante: VarianteBoton = 'primario', tamano: TamanoBoton = 'normal') =>
  cx(
    'foco inline-flex items-center justify-center gap-2 font-bold transition-colors disabled:cursor-not-allowed',
    variantes[variante],
    tamanos[tamano],
  )
